import { r as root } from "./root.js";
import "./server.js";
import "./shared-server.js";
let read_implementation = null;
function set_read_implementation(fn) {
  read_implementation = fn;
}
function set_manifest(_) {
}
const options = {
  app_template_contains_nonce: false,
  async: false,
  csp: { "mode": "auto", "directives": { "upgrade-insecure-requests": false, "block-all-mixed-content": false }, "reportOnly": { "upgrade-insecure-requests": false, "block-all-mixed-content": false } },
  csrf_check_origin: true,
  csrf_trusted_origins: [],
  embedded: false,
  env_public_prefix: "PUBLIC_",
  env_private_prefix: "",
  hash_routing: false,
  hooks: null,
  // added lazily, via `get_hooks`
  preload_strategy: "modulepreload",
  root,
  service_worker: false,
  service_worker_options: null,
  server_error_boundaries: false,
  templates: {
    app: ({ head, body, assets, nonce, env }) => '<!doctype html>\n<html lang="en">\n  <head>\n    <meta charset="utf-8" />\n    <link rel="icon" type="image/svg+xml" href="' + assets + '/favicon.svg" />\n    <link rel="icon" type="image/png" href="' + assets + '/favicon.png" />\n    <meta name="viewport" content="width=device-width, initial-scale=1, viewport-fit=cover" />\n    <meta name="theme-color" content="#0a0a0a" />\n    <link rel="apple-touch-icon" href="' + assets + '/apple-touch-icon.png" />\n    <link rel="manifest" href="' + assets + '/manifest.json" />\n    <meta name="apple-mobile-web-app-capable" content="yes" />\n    <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />\n    <title>Shooter</title>\n    <link rel="preconnect" href="https://fonts.googleapis.com" />\n    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />\n    <link\n      href="https://fonts.googleapis.com/css2?family=Geist:wght@400;500;600;700&family=Geist+Mono:wght@400;500&display=swap"\n      rel="stylesheet"\n    />\n    ' + head + `
  </head>
  <body data-sveltekit-preload-data="hover">
    <script>
      // Global shims for NeuroLink browser SDK — must run before any module code
      (function () {
        var noop = function () {};
        if (typeof globalThis.process === 'undefined') {
          var p = {
            env: {},
            version: 'v24.0.0',
            platform: 'browser',
            argv: [],
            pid: 1,
            cwd: function () {
              return '/';
            },
            exit: noop,
            on: function () {
              return p;
            },
            off: function () {
              return p;
            },
            once: function () {
              return p;
            },
            emit: function () {
              return false;
            },
            removeListener: function () {
              return p;
            },
            addListener: function () {
              return p;
            },
            stdout: {
              write: function () {
                return true;
              },
              on: noop,
            },
            stderr: {
              write: function () {
                return true;
              },
              on: noop,
            },
            stdin: { on: noop },
            nextTick: function (fn) {
              setTimeout(fn, 0);
            },
            hrtime: Object.assign(
              function (t) {
                var n = performance.now() * 1e6;
                var s = Math.floor(n / 1e9);
                var ns = Math.floor(n % 1e9);
                if (!t) return [s, ns];
                var ds = s - t[0];
                var dns = ns - t[1];
                if (dns < 0) {
                  ds -= 1;
                  dns += 1e9;
                }
                return [ds, dns];
              },
              {
                bigint: function () {
                  return BigInt(Math.floor(performance.now() * 1e6));
                },
              }
            ),
            memoryUsage: function () {
              return { rss: 0, heapTotal: 0, heapUsed: 0, external: 0, arrayBuffers: 0 };
            },
            cpuUsage: function () {
              return { user: 0, system: 0 };
            },
            versions: { browser: '1.0.0', node: '24.0.0', v8: '0', modules: '0' },
            release: { name: 'browser' },
            uptime: function () {
              return performance.now() / 1000;
            },
            title: 'browser',
            execPath: '/',
            execArgv: [],
            features: {},
            config: {},
            kill: noop,
            abort: noop,
          };
          globalThis.process = new Proxy(p, {
            get: function (t, k) {
              return k in t ? t[k] : noop;
            },
          });
        }
        if (typeof globalThis.Buffer === 'undefined') {
          function B() {}
          B.from = function (d, e) {
            if (typeof d === 'string') {
              if (e === 'base64') {
                var b = atob(d);
                var u = new Uint8Array(b.length);
                for (var i = 0; i < b.length; i++) u[i] = b.charCodeAt(i);
                return u;
              }
              return new TextEncoder().encode(d);
            }
            return new Uint8Array(d);
          };
          B.alloc = function (n) {
            return new Uint8Array(n);
          };
          B.isBuffer = function (o) {
            return o instanceof Uint8Array;
          };
          B.concat = function (l) {
            var t = 0;
            for (var i = 0; i < l.length; i++) t += l[i].length;
            var r = new Uint8Array(t);
            var o = 0;
            for (var i = 0; i < l.length; i++) {
              r.set(l[i], o);
              o += l[i].length;
            }
            return r;
          };
          B.byteLength = function (s) {
            return new TextEncoder().encode(s).length;
          };
          globalThis.Buffer = B;
        }
        if (typeof globalThis.global === 'undefined') globalThis.global = globalThis;
        var oST = globalThis.setTimeout.bind(globalThis),
          oSI = globalThis.setInterval.bind(globalThis),
          oCT = globalThis.clearTimeout.bind(globalThis),
          oCI = globalThis.clearInterval.bind(globalThis);
        function wT(id) {
          return {
            valueOf: function () {
              return id;
            },
            ref: function () {
              return this;
            },
            unref: function () {
              return this;
            },
            _id: id,
          };
        }
        globalThis.setTimeout = function () {
          return wT(oST.apply(null, arguments));
        };
        globalThis.setInterval = function () {
          return wT(oSI.apply(null, arguments));
        };
        globalThis.clearTimeout = function (t) {
          oCT(t && t._id !== undefined ? t._id : t);
        };
        globalThis.clearInterval = function (t) {
          oCI(t && t._id !== undefined ? t._id : t);
        };
      })();
    <\/script>
    <div style="display: contents">` + body + "</div>\n  </body>\n</html>\n",
    error: ({ status, message }) => '<!doctype html>\n<html lang="en">\n	<head>\n		<meta charset="utf-8" />\n		<title>' + message + `</title>

		<style>
			body {
				--bg: white;
				--fg: #222;
				--divider: #ccc;
				background: var(--bg);
				color: var(--fg);
				font-family:
					system-ui,
					-apple-system,
					BlinkMacSystemFont,
					'Segoe UI',
					Roboto,
					Oxygen,
					Ubuntu,
					Cantarell,
					'Open Sans',
					'Helvetica Neue',
					sans-serif;
				display: flex;
				align-items: center;
				justify-content: center;
				height: 100vh;
				margin: 0;
			}

			.error {
				display: flex;
				align-items: center;
				max-width: 32rem;
				margin: 0 1rem;
			}

			.status {
				font-weight: 200;
				font-size: 3rem;
				line-height: 1;
				position: relative;
				top: -0.05rem;
			}

			.message {
				border-left: 1px solid var(--divider);
				padding: 0 0 0 1rem;
				margin: 0 0 0 1rem;
				min-height: 2.5rem;
				display: flex;
				align-items: center;
			}

			.message h1 {
				font-weight: 400;
				font-size: 1em;
				margin: 0;
			}

			@media (prefers-color-scheme: dark) {
				body {
					--bg: #222;
					--fg: #ddd;
					--divider: #666;
				}
			}
		</style>
	</head>
	<body>
		<div class="error">
			<span class="status">` + status + '</span>\n			<div class="message">\n				<h1>' + message + "</h1>\n			</div>\n		</div>\n	</body>\n</html>\n"
  },
  version_hash: "n5tda4"
};
async function get_hooks() {
  let handle;
  let handleFetch;
  let handleError;
  let handleValidationError;
  let init;
  let reroute;
  let transport;
  return {
    handle,
    handleFetch,
    handleError,
    handleValidationError,
    init,
    reroute,
    transport
  };
}
export {
  set_manifest as a,
  get_hooks as g,
  options as o,
  read_implementation as r,
  set_read_implementation as s
};
